import PageNotFound from '@/pages/PageNotFound';
import { ROUTES } from './routes.config';

export const PageNotFoundRoutes = {
    path: ROUTES.NOT_FOUND,
    element: <PageNotFound />,
};
